/**
 * Percentage formatter for the rate metrics the API returns as 0–1 floats.
 *
 * @param rate Value to format, where 1 is 100%.
 * @returns Formatted percentage, or undefined when there is no value to format.
 */
const formatPercent = (rate: any): string | undefined => {
  if (typeof rate !== 'number' || !Number.isFinite(rate)) {
    return undefined;
  }

  return `${(rate * 100).toFixed(1)}%`;
};

export default formatPercent;
